import { useQuery } from '@tanstack/react-query';
import { loadAssociationBalance } from '../api';
import { AccountStatementResponse } from '~/types';
import { handleApiErrorResponse } from '../handleErrors';

export function usePicktowHistory(associationId?: string) {
  const { data, isLoading, isError, error } = useQuery<{ data: { account_statement: AccountStatementResponse } }>(
    ['accountStatement', associationId],
    () => loadAssociationBalance(associationId),
    {
      enabled: !!associationId,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );

  const errorMessage = isError
    ? (() => {
        const parsed = handleApiErrorResponse(error, 'Erro ao carregar extrato');
        return parsed.handledMessage || parsed.apiError || parsed.applicationErrorMessage || 'Erro ao carregar extrato';
      })()
    : undefined;

  return {
    accountStatement: data?.data?.account_statement,
    loading: Boolean(associationId) && isLoading,
    error: isError,
    errorMessage,
    errorDetails: error,
  };
}

export default usePicktowHistory;
